<template>
  <BackofficeLayout
    :title="$t('message.registration_form.create_application_form')"
    :breadcrumb="breadcrumb"
  >
    <div class="progress-wrapper">
      <ProgressBar
        :percent="progressPercent"
        :prefixText="progressPrefixText"
        :suffixText="progressSuffixText"
      />
    </div>
    <div class="wrapper">
      <div class="main">
        <template v-if="progressStep === 1">
          <v-form ref="form" v-model="valid" validate-on="blur">
            <div class="panel">
              <v-sheet
                class="px-5 py-5 radius-10px"
                color="white"
                rounded
                elevation="1"
              >
                <v-row class="flex-column row-column" no-gutters>
                  <v-col>
                    <p class="form-title">
                      {{ $t("message.registration_form.form_setting") }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-row class="row-form" no-gutters>
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.common.academic_year")
                          }}</label>
                          <v-text-field
                            v-model="form.semesterYear"
                            :rules="[
                              (v) =>
                                !!v ||
                                'message.registration_form.please_fill_academic_year',

                              validateMinYear,
                            ]"
                            :placeholder="
                              $t(
                                'message.registration_form.please_fill_academic_year'
                              )
                            "
                            required
                            v-mask="'####'"
                            hide-details="auto"
                            dense
                            outlined
                            ><template #message="{ message }">
                              {{ $t(message) }}
                            </template></v-text-field
                          >
                        </div>
                      </v-col>
                      <v-col>
                        <!-- <div class="form-group">
                          <label class="required">{{
                            $t("message.registration_form.application_title")
                          }}</label>
                          <v-text-field
                            v-model="form.registerName"
                            type="text"
                            :placeholder="
                              $t(
                                'message.registration_form.placeholder_application_title'
                              )
                            "
                            required
                            :rules="[
                              (v) =>
                                !!v ||
                                'message.registration_form.please_fill_application_title',
                            ]"
                            :error-messages="registerNameError"
                            hide-details="auto"
                            dense
                            outlined
                            ><template #message="{ message }">
                              {{ $t(message) }}
                            </template></v-text-field
                          >
                        </div> -->
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.registration_form.application_grade_level")
                          }}</label>
                          <v-select
                              v-model="form.gradeLevel"
                              @change="changeStudentYear"
                              outlined
                              :items="gradeLevelOptions"
                              :item-text="`label_${locale}`"
                              item-value="value"
                              dense
                          ></v-select>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- opening date -->
                  <v-col>
                    <v-row class="row-form" no-gutters>
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t(
                              "message.registration_form.application_opening_date"
                            )
                          }}</label>
                          <v-menu
                            v-model="openingDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                ref="openingDate"
                                v-model="openingDateDisplay"
                                append-icon="mdi-calendar-blank"
                                :placeholder="
                                  $t(
                                    'message.registration_form.placeholder_datepicker'
                                  )
                                "
                                readonly
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_application_opening_date',
                                ]"
                                dense
                                v-bind="attrs"
                                v-on="on"
                                outlined
                                hide-details="auto"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-date-picker
                              color="orange"
                              v-model="form.openingDate"
                              @input="openingDateMenu = false"
                              :locale="$i18n.locale"
                              :min="minDate"
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <!-- opening time -->
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.common.time")
                          }}</label>
                          <v-menu
                            ref="openingTimeMenu"
                            v-model="openingTimeMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="
                              form.openingTime
                            "
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="form.openingTime"
                                append-icon="mdi-clock-time-four-outline"
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_application_opening_time',
                                ]"
                                outlined
                                dense
                                readonly
                                placeholder="--:--"
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-time-picker
                              format="24hr"
                              :locale="$i18n.locale"
                              v-if="openingTimeMenu"
                              v-model="form.openingTime"
                              full-width
                              @click:minute="
                                $refs.openingTimeMenu.save(
                                  form.openingTime
                                )
                              "
                            ></v-time-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- closing_date -->
                  <v-col>
                    <v-row class="row-form" no-gutters>      
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t(
                              "message.registration_form.application_closing_date"
                            )
                          }}</label>
                          <v-menu
                            v-model="closingDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                ref="closingDate"
                                v-model="closingDateDisplay"
                                append-icon="mdi-calendar-blank"
                                :placeholder="
                                  $t(
                                    'message.registration_form.placeholder_datepicker'
                                  )
                                "
                                openingDateMenu
                                readonly
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_application_closing_date',
                                  () =>
                                    compareDateIsSameOrBefore(
                                      form.openingDate,
                                      form.closingDate,
                                      $t(
                                        'message.registration_form.please_select_application_deadline_date_after_application_available'
                                      )
                                    ),
                                ]"
                                outlined
                                dense
                                v-bind="attrs"
                                v-on="on"
                                hide-details="auto"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-date-picker
                              color="orange"
                              v-model="form.closingDate"
                              @input="closingDateMenu = false"
                              :locale="$i18n.locale"
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <!-- closing time -->
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.common.time")
                          }}</label>
                          <v-menu
                            ref="closingTimeMenu"
                            v-model="closingTimeMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="
                              form.closingTime
                            "
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="form.closingTime"
                                append-icon="mdi-clock-time-four-outline"
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_application_closing_time',
                                ]"
                                outlined
                                dense
                                readonly
                                placeholder="--:--"
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-time-picker
                              format="24hr"
                              :locale="$i18n.locale"
                              v-if="closingTimeMenu"
                              v-model="form.closingTime"
                              full-width
                              @click:minute="
                                $refs.closingTimeMenu.save(
                                  form.closingTime
                                )
                              "
                            ></v-time-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- application fee -->
                  <v-col>
                    <v-row class="row-form" no-gutters>
                      <v-col>
                        <div class="form-group">
                          <label>{{
                            $t("message.registration_form.application_fee")
                          }}</label>
                          <v-switch
                            inset
                            v-model="form.hasRegisterFee"
                            :label="
                              $t(
                                'message.registration_form.enable_to_fill_an_amount_of_application_fee'
                              )
                            "
                            hide-details
                          ></v-switch>
                        </div>
                      </v-col>
                      <v-col> &nbsp; </v-col>
                    </v-row>
                  </v-col>
                  <!-- fee amount -->
                  <v-col v-if="form.hasRegisterFee">
                    <div class="form-row">
                      <div class="form-group">
                        <label class="required">{{
                          $t("message.registration_form.fee_amount")
                        }}</label>
                        <v-text-field
                          v-model="form.fee"
                          :rules="[
                            (v) =>
                              !!v ||
                              'message.registration_form.please_fill_an_amount_of_application_fee',
                            (v) => validateNumberUpTo8Digits(v),
                          ]"
                          outlined
                          placeholder="100"
                          :suffix="$t('message.common.currency.baht')"
                          type="number"
                          step="1"
                          @keypress="validateNumberAndDot($event)"
                          required
                          dense
                          hide-details="auto"
                          ><template #message="{ message }">
                            {{ $t(message) }}
                          </template></v-text-field
                        >
                      </div>
                      <div class="form-group">
                        <label class="required">{{
                          $t("message.registration_form.deadline_of_payment")
                        }}</label>
                        <v-menu
                          v-model="paymentEndDateMenu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              ref="paymentEndDate"
                              outlined
                              v-model="paymentEndDisplay"
                              append-icon="mdi-calendar-blank"
                              :placeholder="
                                $t(
                                  'message.registration_form.placeholder_datepicker'
                                )
                              "
                              openingDateMenu
                              readonly
                              :rules="[
                                (v) =>
                                  !!v ||
                                  'message.registration_form.please_fill_deadline_of_payment',
                                () =>
                                  compareDateIsBefore(
                                    form.openingDate,
                                    form.paymentEndDate,
                                    $t(
                                      'message.registration_form.please_select_date_after_application_available'
                                    )
                                  ),
                                () =>
                                  compareDateIsBefore(
                                    form.paymentEndDate,
                                    form.closingDate,
                                    $t(
                                      'message.registration_form.please_select_date_before_application_deadline'
                                    )
                                  ),
                              ]"
                              dense
                              hide-details="auto"
                              v-bind="attrs"
                              v-on="on"
                              ><template #message="{ message }">
                                {{ $t(message) }}
                              </template></v-text-field
                            >
                          </template>
                          <v-date-picker
                            color="orange"
                            v-model="form.paymentEndDate"
                            @input="paymentEndDateMenu = false"
                            :locale="$i18n.locale"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-sheet>
              <v-sheet
                class="px-5 py-5 radius-10px"
                color="white"
                rounded
                elevation="1"
              >
                <v-row class="flex-column row-column" no-gutters>
                  <v-col>
                    <p class="form-title">
                      {{
                        $t(
                          "message.registration_form.documents_for_application"
                        )
                      }}
                    </p>
                  </v-col>

                  <!-- document start -->
                  <!-- <v-col>
                    <div class="form-row">
                      <div class="form-group">
                        <v-checkbox
                          v-model="form.hasDocumentNationalId"
                          :label="
                            $t('message.registration_form.copy_of_id_card')
                          "
                          hide-details
                        ></v-checkbox>
                      </div>
                      <div class="form-group">
                        <v-checkbox
                          v-model="form.hasDocumentHouseRegistration"
                          :label="
                            $t(
                              'message.registration_form.copy_of_home_registration'
                            )
                          "
                          hide-details
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="form-row">
                      <div class="form-group">
                        <v-checkbox
                          v-model="form.hasDocumentProofOfBirth"
                          :label="
                            $t(
                              'message.registration_form.copy_of_birth_certificate'
                            )
                          "
                          hide-details
                        ></v-checkbox>
                      </div>
                      <div class="form-group">
                        <v-checkbox
                          v-model="form.hasDocumentProofOfNameChanged"
                          :label="
                            $t('message.registration_form.copy_of_name_change')
                          "
                          hide-details
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="form-row">
                      <div class="form-group">
                        <v-checkbox
                          v-model="form.hasDocumentProofOfAdopted"
                          :label="
                            $t(
                              'message.registration_form.copy_of_legitimation_of_child'
                            )
                          "
                          hide-details
                        ></v-checkbox>
                      </div>
                      <div class="form-group">
                        <v-checkbox
                          v-model="form.hasDocumentMedicalCertificate"
                          :label="
                            $t('message.registration_form.medical_certificate')
                          "
                          hide-details
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-col>
                  <v-col>
                    <div class="form-row">
                      <div class="form-group">
                        <v-checkbox
                          v-model="form.hasDocumentTranscript"
                          :label="
                            $t('message.registration_form.copy_of_transcript')
                          "
                          hide-details
                        ></v-checkbox>
                      </div>
                      <div class="form-group">
                        <v-checkbox
                          v-model="form.hasDocumentPortfolio"
                          :label="$t('message.registration_form.portfolio')"
                          hide-details
                        ></v-checkbox>
                      </div>
                    </div>
                  </v-col>
                  <v-col v-if="registrationDocument.length > 0">
                    <v-row class="flex-column row-column" no-gutters>
                      <v-col
                        :key="item.uid"
                        v-for="(item, index) in registrationDocument"
                      >
                        <v-row class="row-form" no-gutters>
                          <v-col>
                            <div class="form-group">
                              <label class="required">{{
                                $t("message.registration_form.document_name")
                              }}</label>
                              <v-text-field
                                v-model="registrationDocument[index].name"
                                type="text"
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_the_document_name_or_delete_the_document_if_not_want_to_create',
                                  (v) => validateDocumentName(v, index),
                                ]"
                                outlined
                                :placeholder="
                                  $t(
                                    'message.registration_form.please_fill_the_document_name'
                                  )
                                "
                                required
                                dense
                                hide-details="auto"
                              >
                                <template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </div>
                          </v-col>
                          <v-col md="auto">
                            <div class="form-group form-icon">
                              <label>&nbsp;</label>
                              <v-icon
                                small
                                @click="removeRegistrationDocument(item)"
                                >mdi-delete</v-icon
                              >
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col> -->

                  <!-- default document -->
                  <v-row no-gutters v-if="defaultDocuments?.length">
                    <v-col cols="6" :key="index" v-for="(item, index) in defaultDocuments">
                      <div class="form-row pb-2">
                        <div class="form-group">
                          <v-checkbox
                            v-model="item.value"
                            readonly
                            :label="item.name"
                            hide-details
                          ></v-checkbox>
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <!-- extra document -->
                  <v-col v-if="registrationDocument?.length">
                    <v-row class="flex-column row-column" no-gutters>
                      <v-col
                        :key="item.uid"
                        v-for="(item, index) in registrationDocument"
                      >
                        <v-row class="row-form" no-gutters>
                          <v-col>
                            <div class="form-group">
                              <label class="required">{{
                                $t("message.registration_form.document_name")
                              }}</label>
                              <v-text-field
                                v-model="registrationDocument[index].name"
                                type="text"
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_the_document_name_or_delete_the_document_if_not_want_to_create',
                                  (v) => validateDocumentName(v, index),
                                ]"
                                outlined
                                :placeholder="
                                  $t(
                                    'message.registration_form.please_fill_the_document_name'
                                  )
                                "
                                required
                                dense
                                hide-details="auto"
                              >
                                <template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </div>
                          </v-col>
                          <v-col md="auto">
                            <div class="form-group form-icon">
                              <label>&nbsp;</label>
                              <v-icon
                                small
                                @click="removeRegistrationDocument(item)"
                                >mdi-delete</v-icon
                              >
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- document end -->

                  <v-col>
                    <div class="form-group">
                      <a
                        class="link link--small link--primary"
                        @click="addRegistrationDocument"
                        >{{ $t("message.common.add") }}</a
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-sheet>
              <v-sheet
                class="px-5 py-5 radius-10px"
                color="white"
                rounded
                elevation="1"
              >
                <v-row class="flex-column row-column" no-gutters>
                  <v-col>
                    <p class="form-title">
                      {{
                        $t(
                          "message.registration_form.announcement_of_qualify_candidates"
                        )
                      }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-row class="row-form" no-gutters>
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.registration_form.announcement_date")
                          }}</label>
                          <v-menu
                            v-model="examAuthorizeAnnouncementDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                ref="examAuthorizeAnnouncementDate"
                                outlined
                                v-model="examAuthorizeAnnouncementDateDisplay"
                                append-icon="mdi-calendar-blank"
                                :placeholder="
                                  $t(
                                    'message.registration_form.placeholder_datepicker'
                                  )
                                "
                                openingDateMenu
                                readonly
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_announcement_date',
                                  () =>
                                    compareDateIsSameOrBefore(
                                      form.closingDate,
                                      form.examAuthorizeAnnouncementDate,
                                      $t(
                                        'message.registration_form.please_select_date_after_application_deadline'
                                      )
                                    ),
                                ]"
                                dense
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-date-picker
                              color="orange"
                              v-model="form.examAuthorizeAnnouncementDate"
                              @input="examAuthorizeAnnouncementDateMenu = false"
                              :locale="$i18n.locale"
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.common.time")
                          }}</label>
                          <v-menu
                            ref="examAuthorizeAnnouncementTimeMenu"
                            v-model="examAuthorizeAnnouncementTimeMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="
                              form.examAuthorizeAnnouncementTime
                            "
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="form.examAuthorizeAnnouncementTime"
                                append-icon="mdi-clock-time-four-outline"
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_announcement_time',
                                ]"
                                outlined
                                dense
                                readonly
                                placeholder="--:--"
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-time-picker
                              format="24hr"
                              :locale="$i18n.locale"
                              v-if="examAuthorizeAnnouncementTimeMenu"
                              v-model="form.examAuthorizeAnnouncementTime"
                              full-width
                              @click:minute="
                                $refs.examAuthorizeAnnouncementTimeMenu.save(
                                  form.examAuthorizeAnnouncementTime
                                )
                              "
                            ></v-time-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <p class="form-title">
                      {{ $t("message.registration_form.exam_date") }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-row class="row-form" no-gutters>
                      <!-- <v-col>
                        <div class="form-group">
                          <div class="form-label">
                            <label class="required">{{
                              $t("message.registration_form.test_venue")
                            }}</label>
                            <v-tooltip right max-width="180" close-delay="1000">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  x-small
                                  class="icon--gray"
                                  v-bind="attrs"
                                  v-on="on"
                                  >mdi-alert-circle</v-icon
                                >
                              </template>
                              <span>{{
                                $t(
                                  "message.registration_form.test_venue_information"
                                )
                              }}</span>
                            </v-tooltip>
                          </div>
                          <v-text-field
                            v-model="form.examLocation"
                            :rules="[
                              (v) =>
                                !!v ||
                                'message.registration_form.please_fill_test_venue',
                            ]"
                            :placeholder="
                              $t(
                                'message.registration_form.placeholder_test_venue'
                              )
                            "
                            outlined
                            required
                            dense
                            hide-details="auto"
                          >
                            <template #message="{ message }">
                              {{ $t(message) }}
                            </template></v-text-field
                          >
                        </div>
                      </v-col> -->
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.registration_form.exam_date_alt")
                          }}</label>
                          <v-menu
                            v-model="examDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                ref="examDate"
                                outlined
                                v-model="examDateDisplay"
                                append-icon="mdi-calendar-blank"
                                :placeholder="
                                  $t(
                                    'message.registration_form.placeholder_datepicker'
                                  )
                                "
                                openingDateMenu
                                readonly
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_exam_date_for_display',
                                  () =>
                                    compareDateIsSameOrBefore(
                                      form.examAuthorizeAnnouncementDate,
                                      form.examDate,
                                      $t(
                                        'message.registration_form.please_select_date_after_announcement_of_qualify_date'
                                      )
                                    ),
                                ]"
                                dense
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-date-picker
                              color="orange"
                              v-model="form.examDate"
                              @input="examDateMenu = false"
                              :locale="$i18n.locale"
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.common.time")
                          }}</label>
                          <v-row class="row-form" no-gutters>
                            <v-col>
                              <v-menu
                                ref="examStartTimePhase1Menu"
                                v-model="examStartTimePhase1Menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form.examStartTimePhase1"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="form.examStartTimePhase1"
                                    append-icon="mdi-clock-time-four-outline"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    readonly
                                    v-bind="attrs"
                                    placeholder="--:--"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  format="24hr"
                                  :locale="$i18n.locale"
                                  v-if="examStartTimePhase1Menu"
                                  v-model="form.examStartTimePhase1"
                                  full-width
                                  @click:minute="
                                    $refs.examStartTimePhase1Menu.save(
                                      form.examStartTimePhase1
                                    )
                                  "
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <!-- <v-col>
                    <v-row class="row-form" no-gutters>
                      <v-col>
                        <div class="form-group">
                          <label>{{
                            $t("message.registration_form.first_exam_period")
                          }}</label>
                          <v-row class="row-form" no-gutters>
                            <v-col>
                              <v-menu
                                ref="examStartTimePhase1Menu"
                                v-model="examStartTimePhase1Menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form.examStartTimePhase1"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="form.examStartTimePhase1"
                                    append-icon="mdi-clock-time-four-outline"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    readonly
                                    v-bind="attrs"
                                    placeholder="--:--"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  format="24hr"
                                  :locale="$i18n.locale"
                                  v-if="examStartTimePhase1Menu"
                                  v-model="form.examStartTimePhase1"
                                  full-width
                                  @click:minute="
                                    $refs.examStartTimePhase1Menu.save(
                                      form.examStartTimePhase1
                                    )
                                  "
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                            <v-col>
                              <v-menu
                                ref="examEndTimePhase1Menu"
                                v-model="examEndTimePhase1Menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form.examEndTimePhase1"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    ref="examEndTimePhase1"
                                    v-model="form.examEndTimePhase1"
                                    append-icon="mdi-clock-time-four-outline"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    readonly
                                    v-bind="attrs"
                                    placeholder="--:--"
                                    v-on="on"
                                    :rules="[
                                      () =>
                                        compareTimeIsBefore(
                                          form.examStartTimePhase1,
                                          form.examEndTimePhase1,
                                          $t(
                                            'message.registration_form.please_select_time_after_start_time'
                                          )
                                        ),
                                    ]"
                                    ><template #message="{ message }">
                                      {{ $t(message) }}
                                    </template></v-text-field
                                  >
                                </template>
                                <v-time-picker
                                  format="24hr"
                                  :locale="$i18n.locale"
                                  v-if="examEndTimePhase1Menu"
                                  v-model="form.examEndTimePhase1"
                                  full-width
                                  @click:minute="
                                    $refs.examEndTimePhase1Menu.save(
                                      form.examEndTimePhase1
                                    )
                                  "
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="form-group">
                          <label>{{
                            $t("message.registration_form.second_exam_period")
                          }}</label>
                          <v-row class="row-form" no-gutters>
                            <v-col>
                              <v-menu
                                ref="examStartTimePhase2Menu"
                                v-model="examStartTimePhase2Menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form.examStartTimePhase2"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="form.examStartTimePhase2"
                                    append-icon="mdi-clock-time-four-outline"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    readonly
                                    v-bind="attrs"
                                    placeholder="--:--"
                                    v-on="on"
                                  ></v-text-field>
                                </template>
                                <v-time-picker
                                  format="24hr"
                                  :locale="$i18n.locale"
                                  v-if="examStartTimePhase2Menu"
                                  v-model="form.examStartTimePhase2"
                                  full-width
                                  @click:minute="
                                    $refs.examStartTimePhase2Menu.save(
                                      form.examStartTimePhase2
                                    )
                                  "
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                            <v-col>
                              <v-menu
                                ref="examEndTimePhase2Menu"
                                v-model="examEndTimePhase2Menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                :return-value.sync="form.examEndTimePhase2"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    ref="examEndTimePhase2"
                                    v-model="form.examEndTimePhase2"
                                    append-icon="mdi-clock-time-four-outline"
                                    outlined
                                    dense
                                    hide-details="auto"
                                    readonly
                                    v-bind="attrs"
                                    placeholder="--:--"
                                    v-on="on"
                                    :rules="[
                                      () =>
                                        compareTimeIsBefore(
                                          form.examStartTimePhase2,
                                          form.examEndTimePhase2,
                                          $t(
                                            'message.registration_form.please_select_time_after_start_time'
                                          )
                                        ),
                                    ]"
                                    ><template #message="{ message }">
                                      {{ $t(message) }}
                                    </template></v-text-field
                                  >
                                </template>
                                <v-time-picker
                                  format="24hr"
                                  :locale="$i18n.locale"
                                  v-if="examEndTimePhase2Menu"
                                  v-model="form.examEndTimePhase2"
                                  full-width
                                  @click:minute="
                                    $refs.examEndTimePhase2Menu.save(
                                      form.examEndTimePhase2
                                    )
                                  "
                                ></v-time-picker>
                              </v-menu>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col> -->
                  <v-col>
                    <p class="form-title">
                      {{
                        $t(
                          "message.registration_form.announcement_of_examination_result_for_first_round"
                        )
                      }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-row class="row-form" no-gutters>
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.registration_form.announcement_date")
                          }}</label>
                          <v-menu
                            v-model="announcementExamResultDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                ref="announcementExamResultDate"
                                outlined
                                v-model="announcementExamResultDateDisplay"
                                append-icon="mdi-calendar-blank"
                                :placeholder="
                                  $t(
                                    'message.registration_form.placeholder_datepicker'
                                  )
                                "
                                openingDateMenu
                                readonly
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_announcement_of_examination_result_for_first_round',
                                  compareDateIsSameOrBefore(
                                    form.examDate,
                                    form.announcementExamResultDate,
                                    $t(
                                      'message.registration_form.please_select_date_after_exam_date'
                                    )
                                  ),
                                ]"
                                dense
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-date-picker
                              color="orange"
                              v-model="form.announcementExamResultDate"
                              @input="announcementExamResultDateMenu = false"
                              :locale="$i18n.locale"
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.common.time")
                          }}</label>
                          <v-menu
                            ref="announcementExamResultTimeMenu"
                            v-model="announcementExamResultTimeMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="form.announcementExamResultTime"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="form.announcementExamResultTime"
                                append-icon="mdi-clock-time-four-outline"
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_announcement_of_examination_result_for_first_round_time',
                                ]"
                                outlined
                                dense
                                hide-details="auto"
                                placeholder="--:--"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-time-picker
                              format="24hr"
                              :locale="$i18n.locale"
                              v-if="announcementExamResultTimeMenu"
                              v-model="form.announcementExamResultTime"
                              full-width
                              @click:minute="
                                $refs.announcementExamResultTimeMenu.save(
                                  form.announcementExamResultTime
                                )
                              "
                            ></v-time-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row class="row-form" no-gutters>
                      <v-col>
                        <div class="form-group">
                          <div class="form-label">
                            <label class="required">{{
                              $t(
                                "message.registration_form.deadline_of_confirmation"
                              )
                            }}</label>
                            <v-tooltip right max-width="230" close-delay="1000">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  x-small
                                  class="icon--gray"
                                  v-bind="attrs"
                                  v-on="on"
                                  >mdi-alert-circle</v-icon
                                >
                              </template>
                              <span>{{
                                $t(
                                  "message.registration_form.deadline_of_confirmation_info"
                                )
                              }}</span>
                            </v-tooltip>
                          </div>
                          <v-menu
                            v-model="announcementExamResultDeadlineDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                ref="announcementExamResultDeadlineDate"
                                outlined
                                v-model="
                                  announcementExamResultDeadlineDateDisplay
                                "
                                append-icon="mdi-calendar-blank"
                                :placeholder="
                                  $t(
                                    'message.registration_form.placeholder_datepicker'
                                  )
                                "
                                openingDateMenu
                                readonly
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_deadline_confirmation_date',
                                  compareDateIsSameOrBefore(
                                    form.announcementExamResultDate,
                                    form.announcementExamResultDeadlineDate,
                                    $t(
                                      'message.registration_form.please_select_date_after_result_announcement_date'
                                    )
                                  ),
                                ]"
                                dense
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-date-picker
                              color="orange"
                              v-model="form.announcementExamResultDeadlineDate"
                              @input="
                                announcementExamResultDeadlineDateMenu = false
                              "
                              :locale="$i18n.locale"
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <v-col> &nbsp; </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <p class="form-title">
                      {{
                        $t(
                          "message.registration_form.announcement_of_examination_result_for_reserve_round"
                        )
                      }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-row class="row-form" no-gutters>
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.registration_form.announcement_date")
                          }}</label>
                          <v-menu
                            v-model="reservedAnnouncementExamResultDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                ref="reservedAnnouncementExamResultDate"
                                outlined
                                v-model="
                                  reservedAnnouncementExamResultDateDisplay
                                "
                                append-icon="mdi-calendar-blank"
                                :placeholder="
                                  $t(
                                    'message.registration_form.placeholder_datepicker'
                                  )
                                "
                                openingDateMenu
                                readonly
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_announcement_of_examination_result_for_reserve_round',
                                  compareDateIsSameOrBefore(
                                    form.examDate,
                                    form.reservedAnnouncementExamResultDate,
                                    $t(
                                      'message.registration_form.please_select_date_after_exam_date'
                                    )
                                  ),
                                ]"
                                dense
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-date-picker
                              color="orange"
                              v-model="form.reservedAnnouncementExamResultDate"
                              @input="
                                reservedAnnouncementExamResultDateMenu = false
                              "
                              :locale="$i18n.locale"
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.common.time")
                          }}</label>
                          <v-menu
                            ref="reservedAnnouncementExamResultTimeMenu"
                            v-model="reservedAnnouncementExamResultTimeMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="
                              form.reservedAnnouncementExamResultTime
                            "
                            transition="scale-transition"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="
                                  form.reservedAnnouncementExamResultTime
                                "
                                append-icon="mdi-clock-time-four-outline"
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_announcement_of_examination_result_for_reserve_round_time',
                                ]"
                                outlined
                                dense
                                hide-details="auto"
                                placeholder="--:--"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-time-picker
                              format="24hr"
                              :locale="$i18n.locale"
                              v-if="reservedAnnouncementExamResultTimeMenu"
                              v-model="form.reservedAnnouncementExamResultTime"
                              full-width
                              @click:minute="
                                $refs.reservedAnnouncementExamResultTimeMenu.save(
                                  form.reservedAnnouncementExamResultTime
                                )
                              "
                            ></v-time-picker>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <v-row class="row-form" no-gutters>
                      <v-col>
                        <div class="form-group">
                          <div class="form-label">
                            <label class="required">{{
                              $t(
                                "message.registration_form.deadline_of_confirmation"
                              )
                            }}</label>
                            <v-tooltip right max-width="240" close-delay="1000">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  x-small
                                  class="icon--gray"
                                  v-bind="attrs"
                                  v-on="on"
                                  >mdi-alert-circle</v-icon
                                >
                              </template>
                              <span>{{
                                $t(
                                  "message.registration_form.deadline_of_confirmation_info"
                                )
                              }}</span>
                            </v-tooltip>
                          </div>
                          <v-menu
                            v-model="
                              reservedAnnouncementExamResultDeadlineDateMenu
                            "
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                ref="reservedAnnouncementExamResultDeadlineDate"
                                outlined
                                v-model="
                                  reservedAnnouncementExamResultDeadlineDateDisplay
                                "
                                append-icon="mdi-calendar-blank"
                                :placeholder="
                                  $t(
                                    'message.registration_form.placeholder_datepicker'
                                  )
                                "
                                openingDateMenu
                                readonly
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_deadline_confirmation_date',
                                  compareDateIsSameOrBefore(
                                    form.reservedAnnouncementExamResultDate,
                                    form.reservedAnnouncementExamResultDeadlineDate,
                                    $t(
                                      'message.registration_form.please_select_date_after_result_announcement_date'
                                    )
                                  ),
                                ]"
                                dense
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-date-picker
                              color="orange"
                              v-model="
                                form.reservedAnnouncementExamResultDeadlineDate
                              "
                              @input="
                                reservedAnnouncementExamResultDeadlineDateMenu = false
                              "
                              :locale="$i18n.locale"
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <v-col>&nbsp;</v-col>
                    </v-row>
                  </v-col>
                  <v-col>
                    <p class="form-title">
                      {{ $t("message.registration_form.the_initiation_day") }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-row class="row-form" no-gutters>
                      <v-col>
                        <div class="form-group">
                          <label class="required">{{
                            $t("message.registration_form.initiation_day")
                          }}</label>
                          <v-menu
                            v-model="enrollmentDateMenu"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                ref="enrollmentDate"
                                outlined
                                v-model="enrollmentDateDisplay"
                                append-icon="mdi-calendar-blank"
                                :placeholder="
                                  $t(
                                    'message.registration_form.placeholder_datepicker'
                                  )
                                "
                                openingDateMenu
                                readonly
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    'message.registration_form.please_fill_initiation_day',
                                  compareDateIsSameOrBefore(
                                    form.announcementExamResultDeadlineDate,
                                    form.enrollmentDate,
                                    $t(
                                      'message.registration_form.please_select_date_after_announcement_of_examination_result_for_first_round'
                                    )
                                  ),
                                  compareDateIsSameOrBefore(
                                    form.reservedAnnouncementExamResultDeadlineDate,
                                    form.enrollmentDate,
                                    $t(
                                      'message.registration_form.please_select_date_after_announcement_of_examination_result_for_reserve_round'
                                    )
                                  ),
                                ]"
                                dense
                                hide-details="auto"
                                v-bind="attrs"
                                v-on="on"
                                ><template #message="{ message }">
                                  {{ $t(message) }}
                                </template></v-text-field
                              >
                            </template>
                            <v-date-picker
                              color="orange"
                              v-model="form.enrollmentDate"
                              @input="enrollmentDateMenu = false"
                              :locale="$i18n.locale"
                            ></v-date-picker>
                          </v-menu>
                        </div>
                      </v-col>
                      <v-col>&nbsp;</v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-sheet>
            </div>
          </v-form>
        </template>
        <template v-else-if="progressStep === 2">
          <div class="panel">
            <v-sheet color="white" class="radius-10px" elevation="1">
              <v-sheet class="px-5 py-5 radius-10px" elevation="0">
                <v-form ref="plan-form">
                  <v-row class="flex-column row-column" no-gutters>
                    <v-col>
                      <p class="form-title">
                        {{
                          $t(
                            "message.registration_form.curriculum_and_grade_level"
                          )
                        }}
                      </p>
                    </v-col>
                    <v-col>
                      <v-row class="row-form" no-gutters>
                        <!-- <v-col class="form-group">
                          <label class="required">{{
                            $t("message.common.grade_level")
                          }}</label>
                          <v-select
                            v-model="selectedStudentYearId"
                            :rules="[
                              (v) =>
                                !!v ||
                                'message.registration_form.placeholder_grade_level',
                            ]"
                            outlined
                            :items="studentYear"
                            :item-text="`label_${$i18n.locale}`"
                            item-value="value"
                            :placeholder="`- ${$t(
                              'message.registration_form.placeholder_grade_level'
                            )} -`"
                            dense
                            hide-details="auto"
                            :item-disabled="disableStudentYear"
                            ><template #message="{ message }">
                              {{ $t(message) }}
                            </template></v-select
                          >
                        </v-col> -->
                        <v-col class="form-group">
                          <label class="required">{{
                            $t("message.registration_form.application_grade_level")
                          }}</label>
                          <v-select
                              v-model="selectedStudentYear"
                              outlined
                              :items="gradeLevelOptions"
                              :item-text="`label_${locale}`"
                              item-value="value"
                              disabled
                              dense
                          ></v-select>
                        </v-col>
                        <v-col class="form-group">
                          <div class="form-label">
                            <label class="required">{{
                              $t("message.common.curriculum")
                            }}</label>
                            <v-tooltip right max-width="240" close-delay="1000">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  x-small
                                  class="icon--gray"
                                  v-bind="attrs"
                                  v-on="on"
                                  >mdi-alert-circle</v-icon
                                >
                              </template>
                              <span>{{
                                $t("message.registration_form.curriculum_info")
                              }}</span>
                            </v-tooltip>
                          </div>
                          <v-select
                            v-model="selectedProgramId"
                            :rules="[
                              (v) =>
                                !!v ||
                                'message.registration_form.placeholder_curriculum',
                            ]"
                            outlined
                            :items="program"
                            :item-text="`label_${$i18n.locale}`"
                            item-value="value"
                            hide-details="auto"
                            :placeholder="`- ${$t(
                              'message.registration_form.placeholder_curriculum'
                            )} -`"
                            dense
                            :item-disabled="disableProgram"
                            ><template #message="{ message }">
                              {{ $t(message) }}
                            </template></v-select
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <v-row class="row-form" no-gutters>
                        <v-col class="form-group">
                          <label class="required">{{
                            $t("message.common.required_amount")
                          }}</label>
                          <v-text-field
                            v-model="totalStudents"
                            :rules="[
                              (v) =>
                                !!v ||
                                'message.registration_form.please_fill_required_amount',
                              (v) =>
                                /^[0-9]*$/.test(v) ||
                                'message.registration_form.please_fill_number',
                            ]"
                            outlined
                            :placeholder="
                              $t(
                                'message.registration_form.placeholder_fill_required_amount'
                              )
                            "
                            :suffix="$t('message.common.person')"
                            type="number"
                            required
                            hide-details="auto"
                            dense
                            ><template #message="{ message }">
                              {{ $t(message) }}
                            </template></v-text-field
                          >
                        </v-col>
                        <v-col class="form-group">
                          <label>&nbsp;</label>
                          <a
                            v-if="disabledAddPlan"
                            class="link link--small link--disabled"
                            >{{
                              $t("message.registration_form.add_to_the_table")
                            }}</a
                          >
                          <a
                            v-else
                            class="link link--small link--primary"
                            @click="addPlan"
                            >{{
                              $t("message.registration_form.add_to_the_table")
                            }}</a
                          >
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </v-sheet>
              <v-data-table
                class="custom-data-table custom-data-table--color"
                :headers="headers"
                :items="plan"
                hide-default-footer
              >
                <template v-slot:[`item.action`]="{ item }">
                  <v-row justify="space-around" align="center" no-gutters
                    ><v-icon small @click="removePlan(item.id)"
                      >mdi-delete</v-icon
                    ></v-row
                  >
                </template>
                <template v-slot:[`item.student_year_name`]="{ item }">
                  {{ item[`student_year_name_${$i18n.locale}`] }}
                </template>
                <template v-slot:[`item.program_name`]="{ item }">
                  {{ item[`program_name_${$i18n.locale}`] }}
                </template>
                <template v-slot:no-data>
                  <div class="custom-data-table-empty-data">
                    <div>
                      <v-icon class="mb-2" large>mdi-plus-box</v-icon>
                      <p>
                        {{
                          $t(
                            "message.registration_form.please_select_grade_level_and_curriculum_available_on_application"
                          )
                        }}
                      </p>
                    </div>
                  </div>
                </template>
              </v-data-table>
              <v-sheet
                v-if="plan.length > 0"
                class="py-5 px-5 radius-10px"
                elevation="0"
                style="border-top: 1px solid #e4e7f2"
              >
                <div class="form-row form-row--end">
                  <div class="form-meta form-meta--right">
                    <p>
                      {{
                        $t("message.registration_form.total_required_amount", {
                          total: totalNumberOfStudentPlan,
                        })
                      }}
                    </p>
                  </div>
                </div>
              </v-sheet>
            </v-sheet>
            <a
              v-if="progressStep === 2"
              class="link link--small icon--link"
              @click="back"
            >
              <v-icon class="icon--primary" small>mdi-chevron-left</v-icon>
              <span class="link--primary text-decoration-underline">{{
                $t("message.common.back")
              }}</span></a
            >
          </div>
        </template>

        <template v-else>
          <v-sheet
            class="px-5 py-5 radius-10px"
            color="white"
            rounded
            elevation="1"
          >
            <div
              v-if="registrationForm && registrationForm.register_link"
              class="result-box"
            >
              <v-icon class="result-icon result-icon-success"
                >mdi-check-circle</v-icon
              >
              <p class="result-title">
                {{
                  $t("message.registration_form.created_an_application_form")
                }}
              </p>
              <p class="result-description">
                {{
                  $t(
                    "message.registration_form.created_an_application_form_description"
                  )
                }}
              </p>
              <v-btn
                v-if="copyToClipboardStatus === 'WAIT'"
                color="primary"
                rounded
                outlined
                @click="copyToClipboard"
                width="260"
              >
                {{ $t("message.registration_form.copy_application_link") }}
                <v-icon right color="primary" small>mdi-content-copy</v-icon>
              </v-btn>
              <v-btn
                v-else-if="copyToClipboardStatus === 'IN_PROGRESS'"
                color="primary"
                rounded
                outlined
                width="260"
              >
                {{ $t("message.registration_form.copy_application_link") }}
                <v-icon right color="primary" small class="rotating"
                  >mdi-loading</v-icon
                >
              </v-btn>
              <v-btn
                v-else
                color="primary"
                rounded
                outlined
                @click="copyToClipboard"
                width="260"
              >
                {{ $t("message.registration_form.copy_application_link") }}
                <v-icon right color="primary" small>mdi-check-circle</v-icon>
              </v-btn>
              <div class="result-extra-description">
                <div class="form-description-wrapper">
                  <v-icon class="icon--blue">mdi-alert-circle</v-icon>
                  <p class="form-title text--black">
                    {{
                      $t(
                        "message.registration_form.created_an_application_form_remark"
                      )
                    }}
                  </p>
                </div>
                <div class="form-description">
                  <ul>
                    <li class="text--gray">
                      {{
                        $t(
                          "message.registration_form.created_an_application_form_remark_1"
                        )
                      }}
                    </li>
                    <li class="text--gray">
                      {{
                        $t(
                          "message.registration_form.created_an_application_form_remark_2"
                        )
                      }}
                    </li>
                    <li class="text--gray">
                      {{
                        $t(
                          "message.registration_form.created_an_application_form_remark_3"
                        )
                      }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div
              v-if="registrationForm && !registrationForm.register_link"
              class="result-box"
            >
              <v-icon class="result-icon result-icon-error"
                >mdi-close-circle</v-icon
              >
              <p class="result-title">
                {{
                  $t(
                    "message.registration_form.failed_to_created_an_application_form"
                  )
                }}
              </p>
              <p class="result-description">
                {{
                  $t(
                    "message.registration_form.please_correct_application_form_link_must_create_before_application_available"
                  )
                }}
              </p>
              <v-btn color="primary" rounded outlined @click="goToEdit">
                <v-icon left color="primary" small>mdi-pencil</v-icon>
                {{ $t("message.registration_form.edit") }}
              </v-btn>
            </div>
          </v-sheet>
        </template>

        <div class="panel">
          <v-sheet
            class="px-5 py-5 radius-10px"
            color="white"
            rounded
            elevation="1"
          >
            <v-row class="flex-column row-column" no-gutters>
              <p class="form-title">
                {{ $t("message.registration_form.online_application_form") }}
              </p>
              <v-col>
                <div class="form-row">
                  <div class="form-meta">
                    <label>{{ $t("message.common.create_at") }}</label>
                    <p>{{ createdAt }}</p>
                  </div>
                  <div class="form-meta">
                    <label>{{ $t("message.common.status") }}</label>
                    <p class="error-text" v-if="formStatus === 'DRAFT'">
                      {{ formStatusText }}
                    </p>
                    <p v-else>{{ formStatusText }}</p>
                  </div>
                </div>
              </v-col>
              <template v-if="isShownGeneralInfo">
                <v-col>
                  <div class="form-row">
                    <div class="form-meta">
                      <label>{{ $t("message.common.academic_year") }}</label>
                      <p>{{ semesterYearText }}</p>
                    </div>
                    <div class="form-meta">
                      <label>{{
                        $t("message.registration_form.application_fee")
                      }}</label>
                      <p>{{ feeText }}</p>
                    </div>
                  </div>
                </v-col>
                <v-col>
                  <div class="form-row">
                    <div class="form-meta">
                      <label>{{
                        $t("message.registration_form.application_period")
                      }}</label>
                      <p class="error-text" v-if="errorRegisterDateRange">
                        {{ registrationDateRangeText }}
                      </p>
                      <p v-else>{{ registrationDateRangeText }}</p>
                    </div>
                  </div>
                </v-col>
              </template>
              <v-col v-if="progressStep !== 3">
                <div class="form-column">
                  <v-btn
                    v-if="progressStep === 1"
                    color="primary"
                    rounded
                    block
                    @click="next"
                    :loading="isSubmitting"
                    :disabled="!canSave"
                  >
                    {{ $t("message.common.next") }}
                  </v-btn>
                  <v-btn
                    v-if="progressStep === 2"
                    color="primary"
                    rounded
                    block
                    @click="next"
                    :loading="isSubmitting"
                    :disabled="!canSave"
                  >
                    {{
                      $t("message.registration_form.create_application_link")
                    }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    rounded
                    outlined
                    block
                    class="button button--rounded button__primary--outline"
                    @click="saveDraft"
                    :loading="isSubmitting"
                    :disabled="!canSave"
                  >
                    {{ $t("message.registration_form.save_draft") }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
          <v-sheet
            v-if="isShownGeneralInfo"
            class="px-5 py-5 radius-10px"
            color="white"
            rounded
            elevation="1"
          >
            <v-row class="flex-column row-column" no-gutters>
              <div class="d-flex align-center justify-space-between">
                <p class="form-title">
                  {{ $t("message.registration_form.information") }}
                </p>
                <a role="button" @click="toggleIsExpandGeneralInformation">
                  <v-icon v-if="isExpandGeneralInformation"
                    >mdi-chevron-down</v-icon
                  >
                  <v-icon v-else>mdi-chevron-up</v-icon>
                </a>
              </div>
              <template v-if="isExpandGeneralInformation">
                <v-col>
                  <div class="form-row">
                    <div class="form-meta">
                      <label>{{
                        $t(
                          "message.registration_form.documents_for_application"
                        )
                      }}</label>
                      <template v-if="registrationDocumentDisplay.length === 0"
                        ><p>-</p></template
                      >
                      <template v-else>
                        <ul>
                          <li
                            :key="`registration-document_${index}`"
                            v-for="(item, index) in registrationDocumentDisplay"
                          >
                            {{ $t(`${item.name}`) }}
                          </li>
                        </ul>
                      </template>
                    </div>
                  </div>
                </v-col>
                <v-col>
                  <div class="form-row">
                    <div class="form-meta">
                      <label>{{
                        $t(
                          "message.registration_form.announcement_of_qualify_candidates"
                        )
                      }}</label>
                      <p>{{ examAuthorizeAnnouncementDateText }}</p>
                    </div>
                    <div class="form-meta">
                      <label>{{
                        $t("message.registration_form.exam_date")
                      }}</label>
                      <p>{{ examDateText }}</p>
                    </div>
                  </div>
                </v-col>
                <v-col>
                  <div class="form-row">
                    <div class="form-meta">
                      <label>{{
                        $t(
                          "message.registration_form.announcement_of_examination_result"
                        )
                      }}</label>
                      <p>{{ announcementExamResultDateText }}</p>
                    </div>
                    <div class="form-meta">
                      <label>{{
                        $t("message.registration_form.deadline_of_confirmation")
                      }}</label>
                      <p>
                        {{ announcementExamResultDeadlineDateText }}
                      </p>
                    </div>
                  </div>
                </v-col>
                <v-col>
                  <div class="form-row">
                    <div class="form-meta">
                      <label>{{
                        $t("message.registration_form.the_initiation_day")
                      }}</label>
                      <p>{{ enrollmentDateText }}</p>
                    </div>
                  </div>
                </v-col>
              </template>
            </v-row>
          </v-sheet>
        </div>
      </div>
    </div>
    <v-dialog v-model="isShowSaveConfirmationModal" width="450">
      <div class="modal__content">
        <v-icon
          class="modal__icon modal__close-button"
          @click="closeSaveConfirmationModal"
          >mdi-close</v-icon
        >
        <v-icon class="modal__icon modal__icon__red">mdi-alert-circle</v-icon>
        <p class="modal__title">
          {{ $t("message.registration_form.do_you_want_to_save_information") }}
        </p>
        <p class="modal__description">
          {{ $t("message.registration_form.information_not_be_saved") }}
        </p>
        <div class="modal__action">
          <v-btn
            color="primary"
            outlined
            rounded
            elevation="0"
            width="180"
            :loading="isSubmitting"
            @click="closeSaveConfirmationModal"
          >
            {{ $t("message.common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            rounded
            elevation="0"
            width="180"
            :loading="isSubmitting"
            @click="next"
          >
            {{ $t("message.common.confirm") }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="isShowSaveDraftConfirmationModal" width="450">
      <div class="modal__content">
        <v-icon
          class="modal__icon modal__close-button"
          @click="closeSaveDraftConfirmationModal()"
          >mdi-close</v-icon
        >
        <v-icon class="modal__icon modal__icon__red">mdi-alert-circle</v-icon>
        <p class="modal__title">
          {{ $t("message.registration_form.do_you_want_to_save_information") }}
        </p>
        <p class="modal__description" v-if="canSave">
          {{ $t("message.registration_form.information_not_be_saved") }}
        </p>
        <p class="modal__description" v-else>
          {{
            $t(
              "message.registration_form.please_fill_all_of_required_field_to_save_information"
            )
          }}
        </p>
        <div class="modal__action">
          <v-btn
            color="primary"
            outlined
            rounded
            elevation="0"
            width="180"
            :loading="isSubmitting"
            @click="closeSaveDraftConfirmationModal(true)"
          >
            {{ $t("message.registration_form.close_without_save") }}
          </v-btn>
          <v-btn
            color="primary"
            rounded
            elevation="0"
            width="180"
            :loading="isSubmitting"
            :disabled="!canSave"
            @click="saveDraft"
          >
            {{ $t("message.common.confirm") }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </BackofficeLayout>
</template>

<script>
import debounce from "@/utils/debounce";
import { v4 as uuidv4 } from "uuid";
import _ from "lodash";
import BackofficeLayout from "@/components/common/BackofficeLayout";
import ProgressBar from "@/components/common/ProgressBar";
import * as dateUtils from "@/utils/date";
import * as services from "@/services";
import {
  FORM_STATUS_MAPPING,
  REGISTRATION_DOCUMENTS,
  DEBOUNCE_SEARCH_MS,
  REGISTRATION_DOCUMENTS_MAPPING,
} from "@/constants";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import router from "@/router";
import i18n from '@/i18n';
import { GRADE_LEVEL_TYPE_OPTIONS } from "@/constants";
dayjs.extend(isSameOrBefore);
const PROGRESS_STEP_1 = 1;
const PROGRESS_STEP_2 = 2;
const PROGRESS_STEP_3 = 3;

export default {
  name: "RegistrationForm",
  components: {
    BackofficeLayout,
    ProgressBar,
  },
  data() {
    const defaultForm = {
      semesterYear: "",
      registerName: "",
      openingDate: "",
      openingTime: "",
      closingDate: "",
      closingTime: "",
      hasRegisterFee: false,
      fee: "",
      paymentEndDate: "",
      hasDocumentNationalId: false,
      hasDocumentHouseRegistration: false,
      hasDocumentProofOfBirth: false,
      hasDocumentProofOfNameChanged: false,
      hasDocumentProofOfAdopted: false,
      hasDocumentMedicalCertificate: false,
      hasDocumentTranscript: false,
      hasDocumentPortfolio: false,
      hasExtraDocument: false,
      examAuthorizeAnnouncementDate: "",
      examAuthorizeAnnouncementTime: "",
      examLocation: "",
      examDate: "",
      examStartTimePhase1: "",
      examEndTimePhase1: "",
      examStartTimePhase2: "",
      examEndTimePhase2: "",
      announcementExamResultDate: "",
      announcementExamResultTime: "",
      announcementExamResultDeadlineDate: "",
      reservedAnnouncementExamResultDate: "",
      reservedAnnouncementExamResultTime: "",
      reservedAnnouncementExamResultDeadlineDate: "",
      enrollmentDate: "",
      gradeLevel: 5,
    };
    return {
      valid: true,
      initialForm: defaultForm,
      registrationForm: null,
      progressPercent: 0,
      progressStep: 1,
      progressStepMax: 3,
      openingDateMenu: false,
      openingTimeMenu: false,
      closingDateMenu: false,
      closingTimeMenu: false,
      paymentEndDateMenu: false,
      examAuthorizeAnnouncementDateMenu: false,
      announcementExamResultDateMenu: false,
      announcementExamResultDeadlineDateMenu: false,
      reservedAnnouncementExamResultDateMenu: false,
      reservedAnnouncementExamResultDeadlineDateMenu: false,
      examAuthorizeAnnouncementTimeMenu: false,
      announcementExamResultTimeMenu: false,
      reservedAnnouncementExamResultTimeMenu: false,
      examStartTimePhase1Menu: false,
      examEndTimePhase1Menu: false,
      examStartTimePhase2Menu: false,
      examEndTimePhase2Menu: false,
      examDateMenu: false,
      enrollmentDateMenu: false,
      link: "",
      formId: null,
      formStatus: "DRAFT",
      form: { ...defaultForm },
      selectedStudentYearId: "",
      selectedProgramId: "",
      totalStudents: "",
      registrationDocument: [],
      plan: [],
      program: [],
      studentYear: [],
      copyToClipboardStatus: "WAIT",
      registerNameError: "",
      isShowSaveConfirmationModal: false,
      isShowSaveDraftConfirmationModal: false,
      isExpandGeneralInformation: true,
      isSubmitting: false,
      minDate: dayjs().add(1, "day").format("YYYY-MM-DD"),
      gradeLevelOptions: GRADE_LEVEL_TYPE_OPTIONS,
      selectedStudentYear: 5,
      defaultDocuments: [
            { name: this.$t('message.doc.extraDoc1'), value: true },
            { name: this.$t('message.doc.extraDoc2'), value: true },
            { name: this.$t('message.doc.extraDoc3'), value: true },
            { name: this.$t('message.doc.extraDoc4'), value: true },
            { name: this.$t('message.doc.extraDoc5'), value: true },
            { name: this.$t('message.doc.extraDoc6'), value: true },
        ],
    };
  },

  mounted() {
    this.getResource();
  },
  methods: {
    async saveDraft() {
      let validate = true;
      if (this.progressStep === PROGRESS_STEP_1) {
        validate = this.$refs["form"].validate();
      }
      if (!validate) return;
      await this.createRegistrationFormConfig(true, true);
    },
    async getResource() {
      try {
        const [programRes, studentYearRes] = await Promise.all([
          services.getProgram(),
          services.getStudentYear(),
        ]);
        this.program = [
          ...programRes.data.data.program.map((item) => ({
            value: item.id,
            label_th: item.program_name_th ?? "",
            label_en: item.program_name_en ?? "",
          })),
        ];
        this.studentYear = [
          ...studentYearRes.data.data.student_year
            .filter((item) => item.value !== 0)
            .map((item) => ({
              value: item.id,
              stdYear: item.value,
              label_th: item.student_year_name_th,
              label_en: item.student_year_name_en,
            })),
        ];

        this.changeStudentYear(this.selectedStudentYear);
      } catch (error) {
        console.log(error);
      }
    },

    async validateRegistrationFormName() {
      try {
        const {
          data: { data },
        } = await services.validateRegistrationFormName({
          register_name: this.form.registerName,
          semester_year: this.form.semesterYear,
        });
        this.registerNameError = data.is_duplicate
          ? this.$t("message.registration_form.application_title_duplicate")
          : "";
      } catch (error) {
        console.log(error);
      }
    },

    async createRegistrationFormConfig(isGoBack = false, isDraft = false) {
      try {
        this.isSubmitting = true;
        const body = this.formatBodyRequest(isDraft);
        const {
          data: { status, data },
        } = await services.createRegistrationForm(body);
        if (status.code === 0 || status.code === 2011) {
          this.formId = data.registration_form.id;
          this.link = data.registration_form.register_link;
          this.formStatus = data.registration_form.form_status;
          this.registrationForm = data.registration_form;
          this.progressPercent = 100;
          this.progressStep = this.progressStep + 1;
          if (isGoBack) {
            router.back(-1);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isShowSaveConfirmationModal = false;
        this.isSubmitting = false;
      }
    },
    async next() {
      if (this.progressStep === PROGRESS_STEP_3) return;
      if (this.progressStep === PROGRESS_STEP_2) {
        await this.createRegistrationFormConfig();
      }
      if (this.progressStep === PROGRESS_STEP_1) {
        const validatedForm = this.$refs["form"].validate();
        if (!validatedForm) return;
        this.progressPercent = 50;
        this.progressStep = this.progressStep + 1;
      }
    },
    back() {
      if (this.progressStep === PROGRESS_STEP_1) return;
      if (this.progressStep === PROGRESS_STEP_2) {
        this.progressPercent = 0;
      }
      if (this.progressStep === PROGRESS_STEP_3) {
        this.progressPercent = 50;
      }
      this.progressStep = this.progressStep - 1;
    },
    addRegistrationDocument() {
      this.registrationDocument = [
        ...this.registrationDocument,
        {
          id: uuidv4(),
          name: "",
        },
      ];
    },
    removeRegistrationDocument(data) {
      this.registrationDocument = this.registrationDocument.filter(
        (item) => item.id !== data.id
      );
    },
    addPlan() {
      const validatedPlan = this.$refs["plan-form"].validate();
      if (!validatedPlan) return;
      const matchedStudentYear = this.studentYear.find(
        (item) => item.value === this.selectedStudentYearId
      );
      const matchedProgram = this.program.find(
        (item) => item.value === this.selectedProgramId
      );
      this.plan = [
        {
          id: uuidv4(),
          total_students: this.totalStudents,
          student_year_id: this.selectedStudentYearId,
          student_year_name_th: matchedStudentYear?.label_th ?? "",
          student_year_name_en: matchedStudentYear?.label_en ?? "",
          program_id: this.selectedProgramId,
          program_name_th: matchedProgram?.label_th ?? "",
          program_name_en: matchedProgram?.label_en ?? "",
        },
        ...this.plan,
      ];
      this.$refs["plan-form"].reset();
      this.$nextTick(() => {
        this.changeStudentYear(this.form.gradeLevel);
      });
    },
    removePlan(id) {
      this.plan = this.plan.filter((item) => item.id !== id);
    },
    copyToClipboard() {
      this.copyToClipboardStatus = "IN_PROGRESS";
      const link = `${window.location.origin}${this.link}`;
      navigator.clipboard.writeText(link);
      setTimeout(() => {
        this.copyToClipboardStatus = "DONE";
      }, 5000);
    },
    openSaveConfirmationModal() {
      this.isShowSaveConfirmationModal = true;
    },
    closeSaveConfirmationModal() {
      this.isShowSaveConfirmationModal = false;
    },
    openSaveDraftConfirmationModal() {
      this.isShowSaveDraftConfirmationModal = true;
    },
    closeSaveDraftConfirmationModal(back = false) {
      this.isShowSaveDraftConfirmationModal = false;
      if (back) {
        router.back();
        return;
      }
      this.$refs["form"].validate();
    },
    formatBodyRequest(isDraft = false) {
      const body = {
        semester_year: this.form.semesterYear,
        // register_name: this.form.registerName,
        register_name: `${this.form.semesterYear} ${this.gradeLevelOptions.find(item => item.value === this.form.gradeLevel)?.[`label_${this.locale}`]}`,
        opening_date: this.form.openingDate,
        opening_time: this.form.openingTime,
        closing_date: this.form.closingDate,
        closing_time: this.form.closingTime,
        has_register_fee: this.form.hasRegisterFee,
        fee: this.form.fee || null,
        payment_end_date: this.form.paymentEndDate || null,
        has_document_national_id: this.form.hasDocumentNationalId,
        has_document_house_registration: this.form.hasDocumentHouseRegistration,
        has_document_proof_of_birth: this.form.hasDocumentProofOfBirth,
        has_document_proof_of_name_changed:
          this.form.hasDocumentProofOfNameChanged,
        has_document_proof_of_adopted: this.form.hasDocumentProofOfAdopted,
        has_document_medical_certificate:
          this.form.hasDocumentMedicalCertificate,
        has_document_transcript: this.form.hasDocumentTranscript,
        has_document_portfolio: this.form.hasDocumentPortfolio,
        has_extra_document: this.form.hasExtraDocument,
        exam_authorize_announcement_date:
          this.form.examAuthorizeAnnouncementDate,
        exam_authorize_announcement_time:
          this.form.examAuthorizeAnnouncementTime,
        exam_location: this.form.examLocation,
        exam_date: this.form.examDate || null,
        exam_start_time_phase1: this.form.examStartTimePhase1,
        exam_end_time_phase1: this.form.examEndTimePhase1,
        exam_start_time_phase2: this.form.examStartTimePhase2,
        exam_end_time_phase2: this.form.examEndTimePhase2,
        announcement_exam_result_date: this.form.announcementExamResultDate,
        announcement_exam_result_time: this.form.announcementExamResultTime,
        announcement_exam_result_deadline_date:
          this.form.announcementExamResultDeadlineDate,
        reserved_announcement_exam_result_date:
          this.form.reservedAnnouncementExamResultDate,
        reserved_announcement_exam_result_time:
          this.form.reservedAnnouncementExamResultTime,
        reserved_announcement_exam_result_deadline_date:
          this.form.reservedAnnouncementExamResultDeadlineDate,
        enrollment_date: this.form.enrollmentDate,
        registration_document: [...this.defaultDocuments, ...this.registrationDocument],
        registration_plans: this.plan,
        is_draft: isDraft,
        grade_level: this.form.gradeLevel,
      };
      return body;
    },
    formatDateTime(date) {
      return dateUtils.formatDateTime(date);
    },
    compareDateIsSameOrBefore(from, to, message) {
      if (!from || !to) return true;
      if (dayjs(to).isSameOrBefore(dayjs(from))) return message;
      return true;
    },
    compareDateIsBefore(from, to, message) {
      if (!from || !to) return true;
      if (dayjs(to).isBefore(dayjs(from))) return message;
      return true;
    },
    compareTimeIsBefore(start, end, message) {
      if (!start || !end) return true;
      if (dateUtils.isBeforeTime(start, end)) return message;
      return true;
    },
    validateNumberAndDot(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]*$/.test(char)) return true;
      else e.preventDefault();
    },
    validateNumberUpTo8Digits(value) {
      const patternTwoDigiAfterComma = /^[1-9][0-9]{0,7}$/;
      if (!value) return true;
      if (!patternTwoDigiAfterComma.test(value))
        return this.$t(
          "message.registration_form.document_name_already_exist_please_change",
          { digit: 8 }
        );
      return true;
    },
    validateDocumentName(name, index) {
      if (!name) return true;
      const extraDocuments = this.registrationDocument
        .filter((item, i) => i !== index)
        .map((item) => item.name);
      if ([...REGISTRATION_DOCUMENTS, ...extraDocuments].includes(name))
        return this.$t(
          "message.registration_form.document_name_already_exist_please_change"
        );
      return true;
    },
    validateMinYear(value) {
      if (!value) return true;
      if (value && value.length < 4) {
        return true;
      }
      const currentYear = +dateUtils.toBuddhistYear(dayjs().format("YYYY"));
      const parsedValue = +value;
      if (parsedValue < currentYear) {
        return this.$t(
          "message.registration_form.cannot_identify_academic_year"
        );
      }
      return true;
    },
    goToEdit() {
      router.push(`/registration/form/${this.registrationForm.id}/edit`);
    },
    disableStudentYear(option) {
      if (!option.value) return true;
      if (!this.selectedProgramId) return false;
      const duplicated = this.plan.find(
        (item) =>
          option.value === item.student_year_id &&
          this.selectedProgramId === item.program_id
      );
      if (duplicated) {
        return true;
      }
      return false;
    },
    disableProgram(option) {
      if (!option.value) return true;
      if (!this.selectedStudentYearId) return false;
      const duplicated = this.plan.find(
        (item) =>
          option.value === item.program_id &&
          this.selectedStudentYearId === item.student_year_id
      );
      if (duplicated) {
        return true;
      }
      return false;
    },
    toggleIsExpandGeneralInformation() {
      this.isExpandGeneralInformation = !this.isExpandGeneralInformation;
    },
    changeStudentYear(value) {
      this.selectedStudentYear = value;
      console.log('selectedStudentYear', this.selectedStudentYear);
      this.selectedStudentYearId = this.getStudentYearId();
      console.log('selectedStudentYearId', this.selectedStudentYearId);
    },
    getStudentYearId() {
      return this.studentYear.find(
        (item) => item.stdYear === this.selectedStudentYear
      )?.value;
    }
  },
  computed: {
    openingDateDisplay() {
      if (!this.form.openingDate) return "";
      return dateUtils.formatDateTime(this.form.openingDate, this.$i18n.locale);
    },
    closingDateDisplay() {
      if (!this.form.closingDate) return "";
      return dateUtils.formatDateTime(this.form.closingDate, this.$i18n.locale);
    },
    paymentEndDisplay() {
      if (!this.form.paymentEndDate) return "";
      return dateUtils.formatDateTime(
        this.form.paymentEndDate,
        this.$i18n.locale
      );
    },
    examAuthorizeAnnouncementDateDisplay() {
      if (!this.form.examAuthorizeAnnouncementDate) return "";
      return dateUtils.formatDateTime(
        this.form.examAuthorizeAnnouncementDate,
        this.$i18n.locale
      );
    },
    examDateDisplay() {
      if (!this.form.examDate) return "";
      return dateUtils.formatDateTime(this.form.examDate, this.$i18n.locale);
    },
    announcementExamResultDateDisplay() {
      if (!this.form.announcementExamResultDate) return "";
      return dateUtils.formatDateTime(
        this.form.announcementExamResultDate,
        this.$i18n.locale
      );
    },
    announcementExamResultDeadlineDateDisplay() {
      if (!this.form.announcementExamResultDeadlineDate) return "";
      return dateUtils.formatDateTime(
        this.form.announcementExamResultDeadlineDate,
        this.$i18n.locale
      );
    },
    reservedAnnouncementExamResultDateDisplay() {
      if (!this.form.reservedAnnouncementExamResultDate) return "";
      return dateUtils.formatDateTime(
        this.form.reservedAnnouncementExamResultDate,
        this.$i18n.locale
      );
    },
    reservedAnnouncementExamResultDeadlineDateDisplay() {
      if (!this.form.reservedAnnouncementExamResultDeadlineDate) return "";
      return dateUtils.formatDateTime(
        this.form.reservedAnnouncementExamResultDeadlineDate,
        this.$i18n.locale
      );
    },
    enrollmentDateDisplay() {
      if (!this.form.enrollmentDate) return "";
      return dateUtils.formatDateTime(
        this.form.enrollmentDate,
        this.$i18n.locale
      );
    },
    formStatusText() {
      return (
        FORM_STATUS_MAPPING[this.formStatus]?.[`text_${this.$i18n.locale}`] ??
        "-"
      );
    },
    semesterYearText() {
      if (!this.form.semesterYear) return "-";
      return this.form.semesterYear;
    },
    registrationDateRangeText() {
      if (!this.form.openingDate || !this.form.closingDate) return "-";
      return `${dateUtils.formatDateTime(
        this.form.openingDate,
        this.$i18n.locale
      )} - ${dateUtils.formatDateTime(
        this.form.closingDate,
        this.$i18n.locale
      )}`;
    },
    examAuthorizeAnnouncementDateText() {
      if (!this.form.examAuthorizeAnnouncementDate) return "-";
      return dateUtils.formatDateTime(
        this.form.examAuthorizeAnnouncementDate,
        this.$i18n.locale
      );
    },
    examDateText() {
      if (!this.form.examDate) return "-";
      return dateUtils.formatDateTime(this.form.examDate, this.$i18n.locale);
    },
    announcementExamResultDateText() {
      if (!this.form.announcementExamResultDate) return "-";
      return dateUtils.formatDateTime(
        this.form.announcementExamResultDate,
        this.$i18n.locale
      );
    },
    announcementExamResultDeadlineDateText() {
      if (!this.form.announcementExamResultDeadlineDate) return "-";
      return dateUtils.formatDateTime(
        this.form.announcementExamResultDeadlineDate,
        this.$i18n.locale
      );
    },
    enrollmentDateText() {
      if (!this.form.enrollmentDate) return "-";
      return dateUtils.formatDateTime(
        this.form.enrollmentDate,
        this.$i18n.locale
      );
    },
    feeText() {
      if (!this.form.fee) return "-";
      return `${this.form.fee} ${this.$t("message.common.currency.baht")}`;
    },
    createdAt() {
      return dateUtils.formatDateTime(null, this.$i18n.locale);
    },
    totalNumberOfStudentPlan() {
      return this.plan
        .map((item) => parseInt(item.total_students))
        .reduce((previous, current) => previous + current, 0);
    },
    progressPrefixText() {
      if (this.progressPercent === 100)
        return this.$t("message.registration_form.transferred");
      if (this.progressPercent === 50)
        return this.$t("message.common.grade_level");
      return this.$t("message.registration_form.information");
    },
    progressSuffixText() {
      return `(${this.progressStep}/${this.progressStepMax})`;
    },
    registrationDocumentDisplay() {
      const document = [];
      for (const [key, value] of Object.entries(
        REGISTRATION_DOCUMENTS_MAPPING
      )) {
        if (this.form[key]) {
          document.push({
            name: value,
          });
        }
      }
      return [...document, ...this.registrationDocument];
    },
    disabledAddPlan() {
      return (
        !this.selectedStudentYearId ||
        !this.selectedProgramId ||
        !this.totalStudents
      );
    },
    breadcrumb() {
      return [
        {
          text: this.$t("message.registration_form.set_up_application_form"),
          link: "/registration/form",
          onClick: this.formChange
            ? () => this.openSaveDraftConfirmationModal()
            : null,
        },
        {
          text: this.$t("message.registration_form.create_application_form"),
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("message.common.grade_level"),
          sortable: false,
          value: "student_year_name",
          width: "30%",
        },
        {
          text: this.$t("message.common.curriculum"),
          value: "program_name",
          sortable: false,
          width: "30%",
        },
        {
          text: this.$t("message.common.required_amount"),
          value: "total_students",
          sortable: false,
          width: "35%",
        },
        {
          text: "",
          value: "action",
          sortable: false,
          width: "5%",
        },
      ];
    },
    formChange() {
      return !_.isEqual(this.initialForm, this.form);
    },
    canSave() {
      let result = true;
      if (this.progressStep === PROGRESS_STEP_2) {
        if (this.plan.length <= 0) {
          result = false;
        }
      }
      return result && this.valid;
    },
    errorRegisterDateRange() {
      if (this.compareDateIsSameOrBefore(new Date(), this.form.openingDate)) {
        return false;
      }
      return true;
    },
    isShownGeneralInfo() {
      return this.progressStep !== PROGRESS_STEP_1;
    },
    locale(){
      return i18n.locale;
    },
  },
  watch: {
    "form.openingDate": function () {
      if (this.progressStep === PROGRESS_STEP_1) {
        this.$refs.closingDate.validate();
        if (this.form.hasRegisterFee) {
          this.$refs.paymentEndDate.validate();
        }
      }
    },
    "form.closingDate": function () {
      if (this.progressStep === PROGRESS_STEP_1) {
        if (this.form.hasRegisterFee) {
          this.$refs.paymentEndDate.validate();
        }
        this.$refs.examAuthorizeAnnouncementDate.validate();
      }
    },
    "form.examAuthorizeAnnouncementDate": function () {
      if (this.progressStep === PROGRESS_STEP_1) {
        this.$refs.examDate.validate();
      }
    },
    "form.examDate": function () {
      if (this.progressStep === PROGRESS_STEP_1) {
        this.$refs.announcementExamResultDate.validate();
        this.$refs.reservedAnnouncementExamResultDate.validate();
      }
    },

    "form.announcementExamResultDate": function () {
      if (this.progressStep === PROGRESS_STEP_1) {
        this.$refs.announcementExamResultDeadlineDate.validate();
      }
    },
    "form.reservedAnnouncementExamResultDate": function () {
      if (this.progressStep === PROGRESS_STEP_1) {
        this.$refs.reservedAnnouncementExamResultDeadlineDate.validate();
      }
    },
    "form.reservedAnnouncementExamResultDeadlineDate": function () {
      if (this.progressStep === PROGRESS_STEP_1) {
        this.$refs.enrollmentDate.validate();
      }
    },
    "form.examStartTimePhase1": function () {
      if (this.progressStep === PROGRESS_STEP_1) {
        this.$refs.examEndTimePhase1.validate();
      }
    },
    "form.examStartTimePhase2": function () {
      if (this.progressStep === PROGRESS_STEP_1) {
        this.$refs.examEndTimePhase2.validate();
      }
    },
    "form.semesterYear": debounce(function (val) {
      this.validateRegistrationFormName(val);
    }, DEBOUNCE_SEARCH_MS),
    "form.registerName": debounce(function (val) {
      this.validateRegistrationFormName(val);
    }, DEBOUNCE_SEARCH_MS),
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 0 24px 24px 24px;
}

.main {
  display: grid;
  grid-template-columns: 1fr 360px;
  align-items: flex-start;
  gap: 30px;
  padding-top: 24px;
}

.panel {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.progress-wrapper {
  height: 54px;
  width: 100%;
  background-color: #ffeacc;
  display: flex;
  justify-content: center;
  align-items: center;
}

.result-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 24px;
}

.result-icon {
  font-size: 50px;
  margin-bottom: 24px;
}

.result-icon-success {
  color: #00c487;
}

.result-icon-error {
  color: #ff544a;
}
.result-title {
  font-family: "Prompt", sans-serif;
  font-size: 24px;
  margin-bottom: 24px;
  .v-application[lang="en"] & {
    font-family: "inter", sans-serif !important;
  }
}

.result-description {
  font-family: "Sarabun", sans-serif;
  font-size: 18px;
  text-align: center;
  margin-bottom: 24px;
  .v-application[lang="en"] & {
    font-family: "inter", sans-serif !important;
  }
}

.result-extra-description {
  margin-top: 64px;
  text-align: left;
}
.error-text {
  color: #ff544a;
}

.radius-10px {
  border-radius: 10px !important;
}
</style>
